import { supabaseClient, useUser } from '@auth-v2';
import { useQuery } from '@tanstack/react-query';

import { getCameraConfig } from '@data';

const getCameraConfigKey = () => ['cameraConifg'];

export const useCameraConfig = (activityId: number) => {
    const { data: user } = useUser();

    return useQuery({
        queryKey: getCameraConfigKey(),
        queryFn: () => getCameraConfig(supabaseClient, activityId),
        enabled: activityId >= 0 && !!user,
    });
};
